import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { Link } from "react-router-dom";
import Breadcrumbs from "../../../components/Breadcrumbs";
import DeleteModal from "../../../components/modelpopup/DeleteModal";
import AddDesingnationModelPopup from "../../../components/modelpopup/AddDesingnationModelPopup";
import SearchBox from "../../../components/SearchBox";
import { companyID } from "../../../auth";
import ProtectedButton from "../../../Routes/Approuter/ProtectedButton";
import { useRole } from "../../../context/RoleContext";
import api from "../../../api/axios";

const Designation = () => {
  const [paginationValue, setPaginationValue] = useState(10);
  const [companyDepartments, setCompanyDepartments] = useState([]);
  const [department, setDepartment] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [deletedID, setDeletedID] = useState("");
  const company_id = companyID();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const openModal = () => {
    setIsModalOpen(true);
  };

  const { role, rolesConfig } = useRole();

  const rolePermissions = rolesConfig[role]?.pages["designations"] || [];

  useEffect(() => {
    api
      .get(`department/department-designation/${company_id}`)
      .then((res) => setCompanyDepartments(res?.data?.result?.reverse()))
      .catch((err) => console.error(err));
  }, []);

  useEffect(() => {
    api
      .get(`department/${company_id}`)
      .then((res) => setDepartment(res?.data?.result))
      .catch((err) => console.error(err));
  }, []);

  const designationData = companyDepartments.map((item, index) => ({
    key: item.designation_id,
    id: index + 1,
    department: item.department_name,
    designation: item.designation_name,
    designation_abbreviation: item.designation_abbreviation,
  }));

  const handleEditDesignation = (id) => {
    const data = companyDepartments.filter(
      (item, _) => item.designation_id == id
    );
    setFilteredData(data);
  };

  const handleDeleteDesignation = async (id) => {
    setDeletedID(id);
    try {
      const res = await api.delete(`department/deleteDesignation/${id}`);
    } catch (err) {
      console.error(err);
    }
  };

  const columns = [
    {
      title: "#",
      dataIndex: "id",
    },
    {
      title: "Department",
      dataIndex: "department",
    },
    {
      title: "Designation",
      dataIndex: "designation",
    },

    {
      title: "Abbreviation",
      dataIndex: "designation_abbreviation",
    },

    ...(rolePermissions.includes("edit", "delete")
      ? [
          {
            title: "Action",
            className: "text-end",
            render: (record) => (
              <div className="dropdown dropdown-action text-end">
                <Link
                  to="#"
                  className="action-icon dropdown-toggle"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <i className="material-icons">more_vert</i>
                </Link>
                <div className="dropdown-menu dropdown-menu-right">
                  <ProtectedButton page="designations" action="edit">
                    <Link
                      className="dropdown-item"
                      to="#"
                      onClick={(e) => {
                        e.preventDefault();
                        setIsEditModalOpen(true);
                        handleEditDesignation(record.key);
                      }}
                    >
                      <i className="fa fa-pencil m-r-5" /> Edit
                    </Link>
                  </ProtectedButton>
                  <ProtectedButton page="designations" action="delete">
                    <Link
                      className="dropdown-item"
                      to="#"
                      // data-bs-toggle="modal"
                      // data-bs-target="#delete"
                      onClick={() => handleDeleteDesignation(record.key)}
                    >
                      <i className="fa fa-trash m-r-5" /> Delete
                    </Link>
                  </ProtectedButton>
                </div>
              </div>
            ),
            width: "10%",
          },
        ]
      : []),
  ];

  const designation = department.map((item, index) => {
    return {
      value: item.id,
      label: item.department_name,
    };
  });

  return (
    <div>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <Breadcrumbs
            maintitle="Designations"
            title="Dashboard"
            subtitle="Designations"
            name="Add  Designation"
            page="designations"
            action="create"
            openModal={openModal}
          />
          <div className="row">
            <div className="col-md-12">
              <div className="table-responsive">
                <SearchBox setPaginationValue={setPaginationValue} />
                <Table
                  columns={columns}
                  dataSource={
                    designationData?.length > 0 ? designationData : []
                  }
                  className="table-striped"
                  rowKey={(record) => record.id}
                  pagination={{ pageSize: paginationValue }}
                  scroll={{ x: true }}
                  tableLayout="auto"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <AddDesingnationModelPopup
        designation={designation}
        company_id={company_id}
        filteredData={filteredData}
        setIsModalOpen={setIsModalOpen}
        isModalOpen={isModalOpen}
        isEditModalOpen={isEditModalOpen}
        setIsEditModalOpen={setIsEditModalOpen}
      />
      <DeleteModal Name="Delete Designation" />
      {(isModalOpen || isEditModalOpen) && (
        <div className="modal-backdrop fade show"></div>
      )}
    </div>
  );
};

export default Designation;
